import React from 'react'
import { styled } from '@mui/system'
import { fontSizes } from '../../consts'

type SloganCardProps = {
  slogan: string
}

export const SloganText = styled('div')(() => ({
  fontWeight: 'bold',
  fontSize: fontSizes.medium,
  textAlign: 'center',
  position: 'relative',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}))

export const SloganCard: React.FC<React.PropsWithChildren<SloganCardProps>> = ({
  slogan,
}) => {
  return <SloganText>{slogan}</SloganText>
}
